import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const BusinessRoute = ({ children }) => {
  const userType = useSelector((state) => state.accountReducer.userInfo?.userType);

  if (userType !== "Business") {
    return <Navigate to="/" />;
  }

  return children;
};

export default BusinessRoute;
